"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.create.title': 'Crear Nueva Pregunta',
};
